import type {
  AssignedMeetingTaskDTO,
  AssignedProjectTaskDTO,
} from "../api/client";

/** ສີປຸ່ມເລືອກສະຖານະ — ສອດຄ່ອງ pending / in_progress / done */
export function assignedTaskStatusSelectTriggerClass(
  variant: "meeting" | "project",
  status:
    | AssignedMeetingTaskDTO["status"]
    | AssignedProjectTaskDTO["status"],
): string {
  if (status === "done") {
    return "border-emerald-600/45 bg-emerald-500/10 font-medium text-emerald-900 shadow-none dark:border-emerald-500/45 dark:text-emerald-100";
  }
  if (variant === "project" && status === "in_progress") {
    return "border-sky-600/45 bg-sky-500/10 font-medium text-sky-950 shadow-none dark:border-sky-500/45 dark:text-sky-100";
  }
  return "border-muted-foreground/35 bg-muted/60 font-medium text-muted-foreground shadow-none";
}

/** ປ້າຍຄວາມສຳຄັນ — ເມື່ອສຳເລັດແລ້ວໃຫ້ຈາງລົງ (ບໍ່ໃຫ້ດູຮີບດ່ວນຄ້າງ) */
export function assignedTaskPriorityBadgeClass(
  priority: "high" | "medium" | "low",
  taskStatus: AssignedProjectTaskDTO["status"],
): string {
  if (taskStatus === "done") {
    return "border-muted-foreground/25 bg-muted/40 text-muted-foreground";
  }
  if (taskStatus === "in_progress") {
    if (priority === "high") {
      return "border-orange-600/50 bg-orange-500/10 text-orange-900 dark:border-orange-500/45 dark:text-orange-100";
    }
    if (priority === "medium") {
      return "border-amber-600/50 bg-amber-500/10 text-amber-950 dark:border-amber-500/45 dark:text-amber-100";
    }
    return "border-sky-600/35 bg-sky-500/8 text-sky-900 dark:border-sky-500/35 dark:text-sky-100";
  }
  /* pending */
  if (priority === "high") {
    return "border-destructive/50 bg-destructive/8 text-destructive";
  }
  if (priority === "medium") {
    return "border-amber-600/50 bg-amber-500/8 text-amber-950 dark:border-amber-500/50 dark:text-amber-100";
  }
  return "border-muted-foreground/35 bg-muted/50 text-muted-foreground";
}

/** ປ້າຍສະຖານະ action ກອງປະຊຸມ (ລາຍການການດຳເນີນໃນບັນທຶກ) — ສີຄືກັບ AssignedTaskStatusSelect */
export function meetingActionStatusBadgeClass(
  status: "pending" | "done",
): string {
  return assignedTaskStatusSelectTriggerClass("meeting", status);
}
